import { type VestiaireAccess, isVestiaireLocked, resolveVestiaireAccess } from '@/features/subscription/vestiaireAccess';
import { useGetCurrentUserVestiaireAccessQuery } from '@/shared/hooks/queries/generated';

/**
 * Accès du plan courant à la recherche Vestiaire Collective (2026-10-01). Tant que la réponse
 * n'est pas arrivée — ou si la requête échoue — rien n'est verrouillé : le serveur refuse de toute
 * façon la création. Invalidé avec les quotas après un changement de plan
 * (`useSubscriptionPlansData.selectPlanDuringTrial`).
 */
export const useVestiaireAccess = (): VestiaireAccess => {
  const { data, isError } = useGetCurrentUserVestiaireAccessQuery(undefined, { staleTime: 60_000, retry: 1 });
  return resolveVestiaireAccess({ value: data?.getCurrentUserVestiaireAccess, failed: isError });
};

/** Vestiaire verrouillé pour le plan courant (réponse connue ET accès refusé). */
export const useVestiaireLocked = (): boolean => isVestiaireLocked(useVestiaireAccess());
